









import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";

@Component
export default class CheckoutAdditionalInfoSummary extends Vue {
    public name = "CheckoutAdditionalInfoSummary";

    @Prop({ type: Object })
    public vm!: CheckoutReviewViewModel;
}
